module.exports = __webpack_public_path__ + "img/background.318e316b.jpg";